// frontend/src/utils/recentPatients.js
//
// Håller en kort lista över senast öppnade patienter per användare i
// localStorage. Skrivs från PatientView och läses av startsidan (Dashboard).
// Medvetet bara lokalt i webbläsaren - ingen patientdata lämnar klienten.

const MAX_RECENT = 8;

const storageKey = (userId) => `aion_recent_patients_${userId}`;

export function getRecentPatients(userId) {
  if (!userId) return [];
  try {
    const raw = localStorage.getItem(storageKey(userId));
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}

export function addRecentPatient(userId, patient) {
  if (!userId || !patient?.patient_id) return;
  try {
    const entry = {
      patient_id: patient.patient_id,
      name: `${patient.firstname || ''} ${patient.lastname || ''}`.trim(),
      opened_at: new Date().toISOString()
    };
    const list = getRecentPatients(userId)
      .filter((p) => p.patient_id !== entry.patient_id);
    list.unshift(entry);
    localStorage.setItem(storageKey(userId), JSON.stringify(list.slice(0, MAX_RECENT)));
  } catch {
    // localStorage kan vara full/blockerad - listan är bara bekvämlighet
  }
}

export function removeRecentPatient(userId, patientId) {
  if (!userId) return;
  try {
    const list = getRecentPatients(userId).filter((p) => p.patient_id !== patientId);
    localStorage.setItem(storageKey(userId), JSON.stringify(list));
  } catch {
    // ignorera
  }
}
